export default __webpack_public_path__ + "static/media/UploadImg.2010ca5f.svg";